// License endpoints (docs/API.md §5). Ed25519 machine-bound keys — NO expiry/renewal.

import { apiGet, apiPost } from "@/lib/api";
import type { License, LicenseKeyResponse } from "@/lib/types";

export function listLicenses(signal?: AbortSignal): Promise<License[]> {
  return apiGet<License[]>("/license", { signal }).then((v) => v ?? []);
}

/** Mint/return the key bound to `machineId` for the user's paid entitlement. Rate-limited. */
export function activateLicense(machineId: string): Promise<LicenseKeyResponse> {
  return apiPost<LicenseKeyResponse>("/license/activate", { machineId });
}

/** Re-sign to a new `machineId` (transfer / new machine). Rate-limited (~once / 30 days). */
export function reissueLicense(machineId: string): Promise<LicenseKeyResponse> {
  return apiPost<LicenseKeyResponse>("/license/reissue", { machineId });
}
